export const Matches = {
  EXPERIMENT_ID: ":experimentId",
  RESOURCE_TYPE: ":resource",
  PATIENT_ID: ":patientId",
  THREAD_ID: ":thread",
  TASK_ID: ":taskId",
  QUEUE_TYPE: ":queue",
  WAIT_ROOM_ID: ":waitRoomId",
  EMPLOYEE_ID: ":employeeId",
  PRODUCT_ID: ":productId",
  INTAKE_ID: ":intakeId",
  QUESTION_ID: ":questionId",
  MEDICATION_ID: ":medicationId",
  PRICE_ID: ":priceId",
  NOTE_TYPE: ":noteType",
  TITRATION_ID: ":titrationId",
  CONVERSATION_ID: ":conversation",
  PROVIDER_ID: ":providerId",
  AVAILABILITY_ID: ":availabilityId",
} as const;

export type MatchParam<T extends keyof typeof Matches> =
  (typeof Matches)[T] extends `:${infer U}` ? U : never;
